export default "__VITE_ASSET__Dd$D8vO___"